import React, {useCallback, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useToggle} from 'react-use';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import './tabs.scss';
import InputSubmit from '../input-submit';

const TabLinks = ({ label, to, edit, dynamic, active, onGoto, onChangeTitle, onSaveTitle}) => {
    return <div style={{cursor: 'pointer', minWidth: 40}} className={classNames('li', active && 'active')}
               onClick={() => {
                   if (edit) return;
                   onGoto(to);
               }} onDoubleClick={onChangeTitle}>
        {edit && dynamic ? <InputSubmit value={label} onSubmit={onSaveTitle}/> : <a className={'btn-link'}>{label}&nbsp;</a>}
    </div>
};

function Tabs(props) {
    const history = useHistory();
    const wrapperRef = useRef(null);

    const {popupList, menuList, editIndex, style, onUpdateTitle, onSaveTitle, onAddFreeTopic} = props;

    const [on, toggle] = useToggle(false);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    const handleClickOutside = useCallback((event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            toggle(false);
        }
    }, []);

    const onGoto = useCallback((to) => {
        history.push(to);
        props.onTabClick();
    }, []);

    return <div className={'tab-container'} style={style}>
        <div className='ul'>
            {menuList.map((menu, index) => (
                <TabLinks
                    key={index.toString()}
                    label={menu.name}
                    to={menu.to}
                    dynamic={menu.dynamic}
                    activeOnlyWhenExact={menu.exact}
                    edit={index === editIndex}
                    onUpdateTitle={() => onUpdateTitle(menu, index)}
                    active={history.location.pathname === menu.to}
                    onGoto={onGoto}
                    onChangeTitle={() => onUpdateTitle(index)}
                    onSaveTitle={(title) => onSaveTitle({...menu, name: title}, index)}
                />
            ))}
        </div>
        <div ref={wrapperRef} className="li plus-button-wrapper" onClick={toggle}>
                    <span className="btn-link">
                        <img src="/img/content/add_circle_24px.svg" alt="alt-text"/>
                    </span>
            {on && (
                <div className="popup-tab-team-report">
                    <ul>
                        {popupList.map((item, idx) => <li key={idx} onClick={() => onAddFreeTopic(item.value)}>
                            {item.name}
                        </li>
                        )}
                    </ul>
                </div>
            )}
        </div>
    </div>
}

Tabs.propTypes = {
    menuList: PropTypes.array.isRequired,
    popupList: PropTypes.array.isRequired,
    editIndex: PropTypes.number,
    style: PropTypes.object,
    onAddFreeTopic: PropTypes.func,
    onTabClick: PropTypes.func,
    onUpdateTitle: PropTypes.func,
    onSaveTitle: PropTypes.func,
};

Tabs.defaultProps = {
    onTabClick: () => {},
    style: {},
};

export default Tabs;
